// <abr-sticky-atc> — sticky add-to-cart on the product page. Size radios feed the hidden
// input[name="id"] of its own <s-product-form>; the main variant picker is mirrored so both
// point at the same variant. On every screen size the bar gets [data-visible] only after the
// main product form has scrolled up out of view.

class AbrStickyAtc extends HTMLElement {
  #ac;
  #observer;
  #mainVisible = true;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    this.addEventListener('change', (event) => {
      const target = event.target;
      if (target instanceof HTMLInputElement && target.matches('[data-sticky-size]')) this.#apply(target.value);
    }, opts);

    // Main picker changed: mirror its variant here.
    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement) || this.contains(target)) return;
      if (!target.closest('s-variant-picker')) return;
      const id = target.dataset.variantId || target.selectedOptions?.[0]?.dataset?.variantId;
      if (id) this.#apply(id, true);
    }, opts);

    const mainForm = document.querySelector('s-product-form[data-product-form]');
    if (mainForm && 'IntersectionObserver' in window) {
      this.#observer = new IntersectionObserver(([entry]) => {
        // Show only once the shopper has scrolled past the main form (it sits above the viewport),
        // not while it is still further down the page below the gallery.
        this.#mainVisible = entry.isIntersecting || entry.boundingClientRect.top > 0;
        this.#updateVisibility();
      });
      this.#observer.observe(mainForm);
    } else {
      this.#mainVisible = false;
    }

    this.#updateVisibility();
    const checked = this.querySelector('[data-sticky-size]:checked');
    if (checked) this.#apply(checked.value);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#observer?.disconnect();
  }

  #updateVisibility() {
    const show = !this.#mainVisible;
    this.toggleAttribute('data-visible', show);
    this.inert = !show;
  }

  #apply(variantId, syncRadio = false) {
    const radio = this.querySelector(`[data-sticky-size][value="${CSS.escape(String(variantId))}"]`);
    if (syncRadio && radio) radio.checked = true;
    const input = this.querySelector('input[name="id"]');
    if (input && radio) input.value = radio.value;

    const button = this.querySelector('[data-sticky-button]');
    if (!button) return;
    const available = radio ? radio.dataset.available === 'true' : true;
    button.disabled = !available;
    button.setAttribute('aria-disabled', String(!available));
    button.classList.toggle('opacity-50', !available);
    button.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
  }
}

if (!customElements.get('abr-sticky-atc')) {
  customElements.define('abr-sticky-atc', AbrStickyAtc);
}
